import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RightRailScrollDirective } from './right-rail-scroll.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [RightRailScrollDirective],
  exports: [RightRailScrollDirective]
})
export class RightRailScrollModule {}
